export default {
  enableLocalUserControl:
    // eslint-disable-next-line turbo/no-undeclared-env-vars
    toBoolean(import.meta.env.VITE_ENABLE_LOCAL_USER_CONTROL) || false
};
function toBoolean(value: string): boolean {
  return value === "true";
}
